export const ADD_WORK = "@workId/ADD"
